import {
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  IconButton,
  Tooltip,
  Typography,
} from "@material-ui/core";
import { Link } from "@material-ui/icons";
import React, { Fragment } from "react";
import { TileProps } from "../../../services/core/types";
import { userRendererStyles } from "./useRendererStyles";

export const TotalCountTile: React.FC<TileProps> = ({ tile, navigate }) => {
  const classes = userRendererStyles();
  return (
    <Grid item xs={12} xl={2} lg={3} md={4}>
      <Card className={classes.root}>
        <CardHeader
          action={
            <Tooltip title={`View list of ${tile.title}`}>
              <IconButton onClick={() => navigate && navigate(tile.filterUrl)}>
                <Link />
              </IconButton>
            </Tooltip>
          }
          title={
            <Typography variant="body1" className={classes.cardHeading}>
              {tile.title}
            </Typography>
          }
          className={classes.header}
        />
        <Divider />
        <CardContent>
          <Grid container>
            {tile.parsedData.map((data, index) => {
              return (
                <Fragment key={index}>
                  {data.title === "Yesterday" ? (
                    <Grid item xs={12}>
                      <Typography
                        variant="body2"
                        className={classes.centerHeader}
                      >
                        {data.value} {data.title}
                      </Typography>
                    </Grid>
                  ) : null}
                  {data.title === "Today" || data.title === "Total" ? (
                    <Grid item xs={12}>
                      <Typography
                        variant="h2"
                        className={classes.centerHeaderMain}
                      >
                        {data.value}
                      </Typography>
                    </Grid>
                  ) : null}
                  {data.title === "Same day last week" ? (
                    <Grid item xs={12}>
                      <Typography
                        variant="body2"
                        className={classes.centerHeader}
                      >
                        {data.value} {data.title}
                      </Typography>
                    </Grid>
                  ) : null}
                </Fragment>
              );
            })}
          </Grid>
        </CardContent>
      </Card>
    </Grid>
  );
};
